import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withConfig } from 'modules/shell/hoc/withConfig';
import SunsetPage from './SunsetPage';
import styles from './SunsetPage.styles';

export default compose(withStyles(styles), withConfig())(SunsetPage);
